import React from 'react';
import PredictionInput from './pages/PredictionInput';
import PredictionDetail from './pages/PredictionDetail';
import History from './pages/History';
import PublicPrompt from './pages/PublicPrompt';
export { configure } from './api';
// No settlement page of its own: each checkpoint is settled in the
// administrator settlement centre.
export const routes = [
  { path: '/multibagger-selection', component: <History /> },
  { path: '/multibagger-selection/create', component: <PredictionInput /> },
  { path: '/multibagger-selection/prompts', component: <PublicPrompt /> },
  { path: '/multibagger-selection/predictions/:id', component: <PredictionDetail /> },
];
export const navigation = { id: 'multibagger-selection', label: 'Multibagger Selection', icon: 'ri-rocket-line', link: '/multibagger-selection' };
export const publicNavigation = { label: 'Multibagger Selection', link: '/multibagger-selection', group: 'AI modes' };
export function getNavigation({ admin }) {
  return { ...navigation, subItems: [
    { id: 'multibagger-selection-history', label: 'History', link: '/multibagger-selection', parentId: navigation.id },
    ...(admin ? [{ id: 'multibagger-selection-input', label: 'Prediction Input', link: '/multibagger-selection/create', parentId: navigation.id }] : []),
  ] };
}
